import React, { useState } from "react";
import { Formik, Form } from "formik";
import Loader from "react-loader-spinner";

import {
  ButtonGroup,
  StyledBankTransferFormButton,
  colors,
} from "../../../../../../../Syles/styles";
import { BankTranferDetailsTextInput } from "../../../../../../../../components/pages/Formik/BankDetailsInput";
import * as Yup from "yup";
import { Util } from "../../../../../../../../helpers/util";

const CreateFixed = ({ setMenu }) => {
  const [fields, setFields] = useState({
    name_of_plan: "",
    target_amount: "",
    automation_status: 0,
    earn_interest: false,
    saving_type: "fixed",
    amount_to_save: "",
    payment_method: "ovest_wallet",
    automatic_payment_method: "ovest_wallet",
  });
  const { currency } = Util.getCurrency();

  const handleNextClick = () => {
    Util.set("create_fixed_plan", fields);

    setMenu(8);
  };

  const setStage = () => {
    handleNextClick();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFields({ ...fields, [name]: value });
  };

  const handleCheckClick = () => {
    setFields({ ...fields, earn_interest: !fields.earn_interest });
  };

  return (
    <div className="create-flexible-plan">
      <div className="create-flexible-plan-main">
        <div className="create-flexible-header">
          <h5 className="create-flexible-h5">Create Fixed Plan</h5>
          <p className="create-flexible-p">
            Save strictly for your goals and earn 7% interest rate every 30 days
          </p>
        </div>
        <div className="savest-amount-tosave">
          <p className="savest-amount-p">
            What would you like to name this plan?{" "}
          </p>
          <Formik
            initialValues={
              {
                // name_of_plan: "",
                // save_amount: "",
                // target_amount: "",
              }
            }
            onSubmit={(values, { setSubmittimg, setFieldError }) => {
              console.log(values);
              // setStage();
            }}
            // validationSchema={Yup.object({
            //   name_of_plan: Yup.string().required(
            //     "Plan Name Field is Required"
            //   ),
            //   save_amount: Yup.string().required("Amount to save is Required"),
            //   target_amount: Yup.string().required("Target amount is Required"),
            // })}
          >
            {({ isSubmitting }) => (
              <Form>
                <BankTranferDetailsTextInput
                  name="name_of_plan"
                  type="text"
                  value={fields.name_of_plan}
                  onChange={handleInputChange}
                  placeholder="Name"
                />

                <div className="amount-targeted">
                  <p className="savest-amount-p2 mt-5">
                    How much would you like to save ?
                  </p>
                  <BankTranferDetailsTextInput
                    name="amount_to_save"
                    value={fields.amount_to_save}
                    onChange={handleInputChange}
                    type="tel"
                    placeholder={currency}
                  />
                  <p className="savest-amount-p2 mt-5">
                    What is your target amount?
                  </p>

                  <BankTranferDetailsTextInput
                    name="target_amount"
                    value={fields.target_amount}
                    onChange={handleInputChange}
                    type="tel"
                    placeholder={currency}
                  />
                </div>
                <div className="checkbox-automate">
                  <p className="savest-amount-p">
                    Do you wish to automate your savings?
                  </p>
                  <input
                    type="radio"
                    id="html"
                    name="automation_status"
                    onChange={handleInputChange}
                    value={0}
                    className=" mt-3"
                  />

                  <label htmlFor="" className="savest-plan-label">
                    Yes, I will like to be debited automatically
                  </label>
                  <br />
                  <input
                    type="radio"
                    id="html"
                    name="automation_status"
                    onChange={handleInputChange}
                    value={1}
                    className=" mt-4"
                  />
                  <label htmlFor="" className="savest-plan-label">
                    No, I will like to save whenever I want
                  </label>
                </div>
                {/* <ButtonGroup>
                  {!isSubmitting && (
                    <StyledBankTransferFormButton
                      type="submit"
                      // onClick={handleNextClick}
                    >
                      Next
                    </StyledBankTransferFormButton>
                  )}

                  {isSubmitting && (
                    <Loader
                      type="ThreeDots"
                      color={colors.primary}
                      height={49}
                      width={100}
                    />
                  )}
                </ButtonGroup> */}
                <button onClick={handleNextClick} className="savest-button">
                  Next
                </button>
              </Form>
            )}
          </Formik>
          <div className="checkbox-main">
            <input
              type="checkbox"
              name="earn_interest"
              onChange={handleCheckClick}
              checked={fields.earn_interest}
              id=""
              className="checkbox-input"
            />
            <label htmlFor="" className="earninterest-savest">
              Earn interest on this saving plan
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateFixed;
